export enum AuthProvider {
  Connect = 'connect',
  Mah = 'mah'
}

export interface Customer {
  customerNumber: string | null;
  country: string | null;
  countryCode: string | null;
  mobileNumber: string | null;
}

export interface UserAuth {
  provider: AuthProvider;
  isAuthorized: boolean;
  isAuthenticated: boolean,
  isLinked?: boolean,
  isDefault?: boolean,
  appEntry?: string,
  auth: {
    accessToken: string | null,
    authCode?: string | null,
    idToken?: string | null,
    expiry: number | undefined, // epoch time
    isNewSession?: boolean,
    tokenType?: string,
  };
  customer: Customer | ConnectCustomer | MAHCustomer;
  loginReq?: any;
}

interface DevOverrides {
  countryOverride?: string,
  customerOverride?: string,
}

export type DevUser = DevOverrides & UserAuth;

export const isDevUser = (user: DevUser | UserAuth): user is DevUser => {
  return 'countryOverride' in (user as DevUser) || 'customerOverride' in (user as DevUser);
};

interface Connect {
  // name: string;
  connectId: string,
  agreementId: string,
  emailAddress: string,
}

export type ConnectCustomer = Customer & Connect;

export const isConnectCustomer = (customer: Customer | ConnectCustomer | MAHCustomer): customer is ConnectCustomer => {
  return 'connectId' in (customer as ConnectCustomer);
};

interface MAH {
  smartCardNumber: string,
  agreementId: string,
  surname: string | null;
  name: string;
}

export type MAHCustomer = Customer & MAH;

export const isMAHCustomer = (customer: Customer | ConnectCustomer | MAHCustomer): customer is MAHCustomer => {
  return 'smartCardNumber' in (customer as MAHCustomer);
};

export interface ConnectStoreBase {
  connectId: string;
  base36Id: string;
  customerNumber: string;
  countryCode: string;
  email: string;
  mobileNumber: string | null;
  newCustomer: boolean;
  Country: string;
  billingCountry: string;
  ProfilePicture: null;
  agreementId: string;
  access_token: string;
  expires_in: null;
  id_token: string;
  token_type: string;
  expires_time: string;
  customer_status: string;
  authenticated: boolean;
  trackingId: unknown;
  expiry: number;
  valid: boolean;
  message: string;
}

export interface ConnectStoreLoginResponse extends ConnectStoreBase {
  CustomerNumber: string;
}

export const isConnectStoreLoginResponse = (customer: ConnectStoreLoginResponse | ConnectStoreBase): customer is ConnectStoreLoginResponse => {
  return 'CustomerNumber' in (customer as ConnectStoreLoginResponse);
};


export interface ConnectRequest {
  accessToken: string;
  expiresIn?: any,
  expiresTime?: any,
  idToken: string;
  trackingId?: string;
  tokenType?: any
}

export interface ConnectRefreshResponse {
  accessToken: string;
  expiresIn: null,
  idToken: string;
  trackingId: string;
}

export interface SmartcardSurnameResponse {
  access_token: string,
  expires_in: number,
  token_type: string,
}

export interface SmartcardSurnameToken {
  ['customer.number']: string,
  ['phone.number']: string,
  ['phone.country.code']: string,
  ['smartcard.number']: string,
  surname: string,
  country: string,
  exp: number,
  iss: string,
  aud: string,
}

export interface ConnectLoginRequest extends ConnectRequest {
  forceReAuth?: boolean;
  foward?: boolean;
}

export interface ConnectUrlResponse {
  access_token: string;
  auth_code?: string,
  expires_in?: string,
  id_token?: string;
  tracking_id?: string;
  token_type?: string
}

export interface ConnectUrlAuthCodeResponse {
  token_type: 'code';
  auth_code: string
  expires_in: number;
}
